import { Injectable } from '@angular/core';

export interface BookingArtist {
  name: string;
  role: string;
  url: string;
}

@Injectable({ providedIn: 'root' })
export class BookingService {

  isOpen = false;

  readonly artists: BookingArtist[] = [
    { name: 'Paige', role: 'Hair & Lashes', url: 'https://www.vagaro.com/veloursalonpaige' },
    { name: 'Lauren', role: 'Hair & Color', url: 'https://book.squareup.com/appointments/3vhshh9bgxt5qf/location/LGF8BX08PFET1/services' },
    { name: 'Samantha', role: 'Lashes', url: 'https://samanthaguerra.glossgenius.com/' },
    { name: 'Hannah', role: 'Nails', url: 'https://thepolishedparlour.glossgenius.com/' }
  ];

  open(): void {
    this.isOpen = true;
  }

  close(): void {
    this.isOpen = false;
  }
}
